import React from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import EMPButton from "../../shared/components/EMPButton/EMPButton";
import * as OrdersPageAnalytics from "../../shared/services/analytics/OrdersPageAnalytics";

// will be refactored in a future story
export const MobileFilters = ({ isDisabled, onOpenFilters, user }) => (
  <Box gridColumn="1 / -1">
    <EMPButton
      onClick={() => {
        OrdersPageAnalytics.trackOpenFilters(user);
        onOpenFilters();
      }}
      variant="outlined"
      disabled={isDisabled}
    >
      Open Filters
    </EMPButton>
  </Box>
);

MobileFilters.propTypes = {
  isDisabled: PropTypes.bool,
  onOpenFilters: PropTypes.func.isRequired,
  user: PropTypes.object,
};

MobileFilters.defaultProps = {
  isDisabled: false,
  user: null,
};
